var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":"","icon":"","x-large":"","color":"#4267B2"},on:{"click":function($event){return _vm.submit()}}},[_c('v-icon',[_vm._v("facebook")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }